import { __assign } from 'tslib';
import * as React from 'react';
import { contentfulComponentsMap, AtomSectionContext } from '@invitae/cms-blocks';
import { NucleobaseComponentMapContext, NucleobaseEngineContext, BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import { useContentfulEngine } from '@invitae/nucleobase-engine-contentful';

var engine = {
    useEngine: useContentfulEngine,
};
var BaseMarcomContext = function (_a) {
    var children = _a.children;
    var customMapping = React.useContext(NucleobaseComponentMapContext);
    return (React.createElement(NucleobaseComponentMapContext.Provider, { value: __assign(__assign({}, contentfulComponentsMap), customMapping) },
        React.createElement(NucleobaseEngineContext.Provider, { value: engine },
            React.createElement(AtomSectionContext.Provider, { value: { BaseNucleobaseComponent: BaseNucleobaseComponent } }, children))));
};

export { BaseMarcomContext as default };
//# sourceMappingURL=BaseMarcomContext.esm.js.map
